
// RecHairRemoval.jsx - Professional Hair Removal & Skincare Guide
import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../contexts/I18n";
import "./recommended.css";

const recommendedItems = [
  { title: "hairTrendsStylingGuide", image: "images/hair.jpg", slug: "hair-&-nail-salon" },
  { title: "mensGroomingMustacheStyles", image: "images/barbershop.jpg", slug: "barbershop" },
  { title: "tattooIdeasArtistGuide", image: "images/tattoo.jpg", slug: "tattoo-&-piercing-shops" },
  { title: "hairRemovalSkincare", image: "images/hair1.jpg", slug: "hair-removal" },
  { title: "browLashEnhancement", image: "images/brows.jpg", slug: "makeup-&-brows-&-lashes" },
  { title: "spaWellnessTreatments", image: "images/massage.jpg", slug: "massage-&-aesthetic-medicine" },
];

/* Sections with practical, immediately useful content for clients */
const getSections = (t) => [
  {
    id: "hair-removal-methods",
    title: "professionalHairRemovalMethods",
    description: "compareDifferentHairRemoval",
    readingTime: "6 min read",
    difficulty: "Beginner",
    image: "/images/hair1.jpg",
    quickTips: [
      "considerSkinSensitivity",
      "factorPainTolerance",
      "chooseMethodsFitBudget"
    ],
    content: (
      <>
        <p>{t('recHairRemovalMethodsIntro')}</p>

        <h4>{t('recHairRemovalMethodsTitle')}</h4>
        
        <h5>{t('recHairRemovalLaserTitle')}</h5>
        <p>
          <strong>{t('recHairRemovalHowItWorks')}</strong> {t('recHairRemovalLaserHow')}
        </p>
        <p>
          <strong>{t('recHairRemovalBestFor')}</strong> {t('recHairRemovalLaserBest')}
        </p>
        <p>
          <strong>{t('recHairRemovalDuration')}</strong> {t('recHairRemovalLaserDuration')}
        </p>
        <p>
          <strong>{t('recHairRemovalMaintenance')}</strong> {t('recHairRemovalLaserMaintenance')}
        </p>
        
        <h5>{t('recHairRemovalWaxingTitle')}</h5>
        <p>
          <strong>{t('recHairRemovalHowItWorks')}</strong> {t('recHairRemovalWaxingHow')}
        </p>
        <p>
          <strong>{t('recHairRemovalBestFor')}</strong> {t('recHairRemovalWaxingBest')}
        </p>
        <p>
          <strong>{t('recHairRemovalDuration')}</strong> {t('recHairRemovalWaxingDuration')}
        </p>
        <p>
          <strong>{t('recHairRemovalMaintenance')}</strong> {t('recHairRemovalWaxingMaintenance')}
        </p>
        
        <h5>{t('recHairRemovalSugaringTitle')}</h5>
        <p>
          <strong>{t('recHairRemovalHowItWorks')}</strong> {t('recHairRemovalSugaringHow')}
        </p>
        <p>
          <strong>{t('recHairRemovalBestFor')}</strong> {t('recHairRemovalSugaringBest')}
        </p>
        <p>
          <strong>{t('recHairRemovalDuration')}</strong> {t('recHairRemovalSugaringDuration')}
        </p>
        <p>
          <strong>{t('recHairRemovalMaintenance')}</strong> {t('recHairRemovalSugaringMaintenance')}
        </p>
        
        <h5>{t('recHairRemovalElectrolysisTitle')}</h5>
        <p>
          <strong>{t('recHairRemovalHowItWorks')}</strong> {t('recHairRemovalElectrolysisHow')}
        </p>
        <p>
          <strong>{t('recHairRemovalBestFor')}</strong> {t('recHairRemovalElectrolysisBest')}
        </p>
        <p>
          <strong>{t('recHairRemovalDuration')}</strong> {t('recHairRemovalElectrolysisDuration')}
        </p>
        <p>
          <strong>{t('recHairRemovalMaintenance')}</strong> {t('recHairRemovalElectrolysisMaintenance')}
        </p>
      </>
    ),
  },
  {
    id: "skin-preparation",
    title: "skinPreparationPreTreatment",
    description: "learnEssentialSkinPreparation",
    readingTime: "5 min read",
    difficulty: "Beginner",
    image: "/images/hair1.jpg",
    quickTips: [
      "exfoliateBeforeTreatment",
      "avoidSunExposure",
      "stopUsingRetinoids"
    ],
    content: (
      <>
        <p>{t('recHairRemovalSkinPrepIntro')}</p>

        <h4>{t('recHairRemovalPreTreatmentGuidelines')}</h4>
        
        <h5>{t('recHairRemovalSkinPreparation')}</h5>
        <ul>
          <li><strong>{t('recHairRemovalExfoliation')}</strong> {t('recHairRemovalExfoliationText')}</li>
          <li><strong>{t('recHairRemovalHydration')}</strong> {t('recHairRemovalHydrationText')}</li>
          <li><strong>{t('recHairRemovalCleanSkin')}</strong> {t('recHairRemovalCleanSkinText')}</li>
          <li><strong>{t('recHairRemovalHairLength')}</strong> {t('recHairRemovalHairLengthText')}</li>
        </ul>
        
        <h5>{t('recHairRemovalWhatToAvoid')}</h5>
        <ul>
          <li><strong>{t('recHairRemovalSunExposure')}</strong> {t('recHairRemovalSunExposureText')}</li>
          <li><strong>{t('recHairRemovalRetinoids')}</strong> {t('recHairRemovalRetinoidsText')}</li>
          <li><strong>{t('recHairRemovalAcids')}</strong> {t('recHairRemovalAcidsText')}</li>
          <li><strong>{t('recHairRemovalMedications')}</strong> {t('recHairRemovalMedicationsText')}</li>
        </ul>
        
        <h4>{t('recHairRemovalTreatmentDayPrep')}</h4>
        
        <h5>{t('recHairRemovalBeforeAppointment')}</h5>
        <ul>
          <li><strong>{t('recHairRemovalComfortableClothing')}</strong> {t('recHairRemovalComfortableClothingText')}</li>
          <li><strong>{t('recHairRemovalHydrationDrink')}</strong> {t('recHairRemovalHydrationDrinkText')}</li>
          <li><strong>{t('recHairRemovalPainManagement')}</strong> {t('recHairRemovalPainManagementText')}</li>
          <li><strong>{t('recHairRemovalQuestions')}</strong> {t('recHairRemovalQuestionsText')}</li>
        </ul>
      </>
    ),
  },
  {
    id: "aftercare-healing",
    title: "postTreatmentCareHealing",
    description: "masterAftercareRoutine",
    readingTime: "4 min read",
    difficulty: "Beginner",
    image: "/images/hair1.jpg",
    quickTips: [
      "keepTreatedAreasCool",
      "avoidSunExposureHeat",
      "dontPickScratch"
    ],
    content: (
      <>
        <p>{t('recHairRemovalAftercareIntro')}</p>

        <h4>{t('recHairRemovalImmediateAftercare')}</h4>
        
        <h5>{t('recHairRemovalFirst24Hours')}</h5>
        <ul>
          <li><strong>{t('recHairRemovalCooling')}</strong> {t('recHairRemovalCoolingText')}</li>
          <li><strong>{t('recHairRemovalMoisturizing')}</strong> {t('recHairRemovalMoisturizingText')}</li>
          <li><strong>{t('recHairRemovalAvoidHeat')}</strong> {t('recHairRemovalAvoidHeatText')}</li>
          <li><strong>{t('recHairRemovalLooseClothing')}</strong> {t('recHairRemovalLooseClothingText')}</li>
        </ul>
        
        <h5>{t('recHairRemovalFirstWeek')}</h5>
        <ul>
          <li><strong>{t('recHairRemovalGentleCleansing')}</strong> {t('recHairRemovalGentleCleansingText')}</li>
          <li><strong>{t('recHairRemovalSunProtection')}</strong> {t('recHairRemovalSunProtectionText')}</li>
          <li><strong>{t('recHairRemovalNoExfoliation')}</strong> {t('recHairRemovalNoExfoliationText')}</li>
          <li><strong>{t('recHairRemovalHydrationKeep')}</strong> {t('recHairRemovalHydrationKeepText')}</li>
        </ul>
        
        <h4>{t('recHairRemovalHealingTimeline')}</h4>
        
        <h5>{t('recHairRemovalWhatToExpect')}</h5>
        <ul>
          <li><strong>{t('recHairRemovalDay12')}</strong> {t('recHairRemovalDay12Text')}</li>
          <li><strong>{t('recHairRemovalDay35')}</strong> {t('recHairRemovalDay35Text')}</li>
          <li><strong>{t('recHairRemovalWeek2')}</strong> {t('recHairRemovalWeek2Text')}</li>
          <li><strong>{t('recHairRemovalWeek34')}</strong> {t('recHairRemovalWeek34Text')}</li>
        </ul>
      </>
    ),
  },
  {
    id: "troubleshooting",
    title: "commonIssuesTroubleshooting",
    description: "learnIdentifyResolve",
    readingTime: "5 min read",
    difficulty: "Beginner",
    image: "/images/hair1.jpg",
    quickTips: [
      "mostSideEffectsTemporary",
      "contactTechnicianPersistent",
      "followAftercareInstructions"
    ],
    content: (
      <>
        <p>{t('recHairRemovalTroubleshootingIntro')}</p>

        <h4>{t('recHairRemovalCommonSideEffects')}</h4>
        
        <h5>{t('recHairRemovalNormalReactions')}</h5>
        <ul>
          <li><strong>{t('recHairRemovalRedness')}</strong> {t('recHairRemovalRednessText')}</li>
          <li><strong>{t('recHairRemovalSwelling')}</strong> {t('recHairRemovalSwellingText')}</li>
          <li><strong>{t('recHairRemovalTenderness')}</strong> {t('recHairRemovalTendernessText')}</li>
          <li><strong>{t('recHairRemovalDryness')}</strong> {t('recHairRemovalDrynessText')}</li>
        </ul>
        
        <h5>{t('recHairRemovalWhenToSeekHelp')}</h5>
        <ul>
          <li><strong>{t('recHairRemovalExcessiveRedness')}</strong> {t('recHairRemovalExcessiveRednessText')}</li>
          <li><strong>{t('recHairRemovalSevereSwelling')}</strong> {t('recHairRemovalSevereSwellingText')}</li>
          <li><strong>{t('recHairRemovalSignsOfInfection')}</strong> {t('recHairRemovalSignsOfInfectionText')}</li>
          <li><strong>{t('recHairRemovalAllergicReactions')}</strong> {t('recHairRemovalAllergicReactionsText')}</li>
        </ul>
        
        <h4>{t('recHairRemovalPreventionTips')}</h4>
        
        <h5>{t('recHairRemovalAvoidingComplications')}</h5>
        <ul>
          <li><strong>{t('recHairRemovalFollowInstructions')}</strong> {t('recHairRemovalFollowInstructionsText')}</li>
          <li><strong>{t('recHairRemovalChooseQualifiedProviders')}</strong> {t('recHairRemovalChooseQualifiedProvidersText')}</li>
          <li><strong>{t('recHairRemovalCommunicateConcerns')}</strong> {t('recHairRemovalCommunicateConcernsText')}</li>
          <li><strong>{t('recHairRemovalPatchTesting')}</strong> {t('recHairRemovalPatchTestingText')}</li>
        </ul>
      </>
    ),
  },
];

export default function RecHairRemoval() {
  const { t, lang } = useI18n();
  const sections = getSections(t);
  
  const handleTocClick = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  
  return (
    <div className="rec-page" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <details className="rec-mobile-panel" role="navigation" aria-label={t('recommendedServices')}>
        <summary>
          {t('recommendedServices')}
                    <span className="rec-plus" aria-hidden="true">+</span>

          <span className="rec-plus" aria-hidden="true"></span>
        </summary>
        <ul className="rec-quick-list">
          {recommendedItems.map((it) => (
            <li key={it.slug}>
              <Link to={`/rec/${it.slug}`}>{t(it.title)}</Link>
            </li>
          ))}
        </ul>
      </details>

      <aside className="rec-left" aria-label={t('recommendedServices')}>
        <h2 className="rec-left__title">{t('recommendedServices')}</h2>
        <ul className="rec-left__list">
          {recommendedItems.map((it) => (
            <li key={it.slug} className="rec-left__item">
              <Link to={`/rec/${it.slug}`} className="rec-left__link">
                <img className="rec-left__thumb" src={`/${it.image}`} alt="" />
                <span className="rec-left__label">{t(it.title)}</span>
              </Link>
            </li>
          ))}
        </ul>
      </aside>

      <article className="rec-article">
        <header className="rec-hero">
          <h1>{t('recommendedServices')}</h1>
          <p className="rec-meta">{t('recHairRemovalGuideMeta')}</p>
          <p className="rec-dek">
            {t('recHairRemovalIntro')}
          </p>
          <div className="rec-cta-row">
            <Link className="btn primary" to="/service/hair-removal">{t('recBookHairRemoval')}</Link>
            <Link className="btn outline" to="/service/hair-removal">{t('recViewAllServices')}</Link>
          </div>
        </header>

        <nav className="rec-toc" aria-label="Table of Contents">
          <h2>{t('tableOfContents')}</h2>
          <div className="rec-toc-summary">
            <p><strong>{sections.length} {t('sections')}</strong> • <strong>{sections.reduce((total, sec) => total + parseInt(sec.readingTime), 0)} {t('minTotalRead')}</strong></p>
          </div>
          <ul className="rec-toc-list">
            {sections.map((sec, index) => (
              <li key={sec.id} className="rec-toc-item">
                <a href={`#${sec.id}`} className="rec-toc-link" onClick={(e) => handleTocClick(e, sec.id)}>
                  <div className="rec-toc-content">
                    <h3 className="rec-toc-title">{t(sec.title)}</h3>
                    <p className="rec-toc-description">{t(sec.description)}</p>
                    <div className="rec-toc-meta">
                      <span className="rec-toc-time">{sec.readingTime}</span>
                      <span className={`rec-toc-difficulty rec-toc-difficulty--${sec.difficulty.toLowerCase()}`}>
                        {sec.difficulty}
                      </span>
                    </div>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {sections.map((sec, index) => (
          <section key={sec.id} id={sec.id} className="rec-section">
            <div className="rec-section-header">
              <div className="rec-section-info">
                <h3>{t(sec.title)}</h3>
                <div className="rec-section-details">
                  <span className="rec-section-time">{sec.readingTime}</span>
                  <span className={`rec-section-difficulty rec-section-difficulty--${sec.difficulty.toLowerCase()}`}>
                    {sec.difficulty}
                  </span>
                </div>
              </div>
            </div>
            <div className="rec-section-intro">
              <p>{t(sec.description)}</p>
            </div>
            <div className="rec-quick-tips">
              <h4>{t('quickTips')}</h4>
              <ul className="rec-tips-list">
                {sec.quickTips.map((tip, tipIndex) => (
                  <li key={tipIndex} className="rec-tip-item">
                    <span className="rec-tip-text">{t(tip)}</span>
                    <span className="rec-tip-icon">💡</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="rec-section-body">
              <div className="rec-section-content">
                <div>
                  {sec.content}
                </div>
              </div>
            </div>
          </section>
        ))}

        <footer className="rec-footer">
          <h3>{t('recommendedServices')}</h3>
          <p>
            {t('recHairRemovalFooter')}
          </p>
          <div className="rec-cta-row">
            <Link className="btn primary" to="/service/hair-removal">{t('recBookHairRemoval')}</Link>
            <Link className="btn outline" to="/service/hair-removal">{t('recBookConsultation')}</Link>
          </div>
        </footer>
      </article>
    </div>
  );
}
